import { Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { fDateTime } from "minimals-template/components/utils/formatTime"

/**
 * Token STATE only — counts and last use. There is deliberately nothing here to render a token
 * value, hash or prefix with: the server type does not carry them, and the tenant's own SCIM
 * Connection tab remains the only place a token is ever shown, once, at creation.
 */
export function EstateTokensCell({ tokens }) {
    const active = tokens?.active ?? 0
    const revoked = tokens?.revoked ?? 0

    return (
        <Stack spacing={0.25}>
            <Typography variant="body2" color={activeColour()}>
                {`${active} active`}
            </Typography>
            <If value={revoked > 0}>
                <Typography variant="caption" color="text.secondary">
                    {`${revoked} revoked`}
                </Typography>
            </If>
            <Typography variant="caption" color="text.secondary">
                {lastUsed()}
            </Typography>
        </Stack>
    )

    function activeColour() {
        return active ? "text.primary" : "text.secondary"
    }

    function lastUsed() {
        if (!tokens?.lastUsedAt) return "never used"
        return `used ${fDateTime(tokens.lastUsedAt)}`
    }
}
